import ColumnDefinition from '../../../../infrastructure/types/DataGrid/ColumnDefinition';
import React from 'react';
import Version from '../../../../types/common/Version';
import versionHelper from '../../../../infrastructure/helpers/functions/common/versionHelper';

const getColumns = (onGetChangesClick: (identifier: string) => Promise<void>): ColumnDefinition<Version>[] => {
    return [
        {
            header: 'Version',
            getContent: x => versionHelper.getDisplayName(x.identifier),
            width: '90px'
        },
         {
            header: 'Change Name',
            getContent: x => x.name,
            width: '200px',
            className: 'break-all'
        },
        {
            header: 'Change Comment',
            getContent: x => x.comment,
            className: 'break-all'
        },
        {
            header: 'Timestamp',
            getContent: x => x.timestamp,
            sortKey: 'Timestamp',
            width: '180px'
        },
        {
            header: 'User',
            getContent: x => x.user
        },
        {
            header: '',
            getContent: x => <button className="transparent-button" onClick={() => onGetChangesClick(x.identifier)}>Changes</button>,
            width: '80px'
        }
    ];
}

export default getColumns;